import { Germany } from '@corratech/air-ooka-header/StoreSwitcher/Flags/Germany'
import { UAE } from '@corratech/air-ooka-header/StoreSwitcher/Flags/UAE'
import { useTranslation } from 'next-i18next'
import { useStoreConfig } from '@config/hooks/useStoreConfig'

type LocalesType =
    | { de: string; en: string }
    | { ar: string; en: string }
    | { en: string }

export type StoreSwitcherConfigType = {
    country: string
    locales: LocalesType
    flag: JSX.Element
    store: string
    url: string
}
export const useStoreSwitcherConfig = (): StoreSwitcherConfigType[] => {
    const { t } = useTranslation('common')
    const config = useStoreConfig()

    return [
        {
            store: 'ooka_uae_store',
            locales: { ar: t(`localeNames|ar`), en: t(`localeNames|en`) },
            flag: <span />, // hide flag
            country: t('ME'),
            url: config.base?.otherWebsiteUrls?.ooka_ae as string
        }
    ]
}
